import { useQuery } from '@tanstack/react-query';

import { getPayments } from '~/services/PaymentsService';

export const orderPaymentsQueryKeys = {
  all: ['orderPayments'] as const,
  details: () => [...orderPaymentsQueryKeys.all, 'detail'] as const,
  detail: (orderId: string) => [...orderPaymentsQueryKeys.details(), orderId] as const,
};

export function useGetOrderPayments(orderId: string, enabled = true) {
  return useQuery({
    queryKey: orderPaymentsQueryKeys.detail(orderId),
    queryFn: () => getPayments(orderId),
    enabled: Boolean(orderId) && enabled,
    staleTime: 60_000,
    retry: false,
  });
}
